// =============================================================
// DashboardLayout  Shell wrapping authenticated pages
// =============================================================

import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useState } from 'react';

interface Props {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  breadcrumbs?: Array<{ label: string; to?: string }>;
}

export function DashboardLayout({ children, title, subtitle, breadcrumbs }: Props) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={`app-shell ${mobileNavOpen ? 'nav-open' : ''}`}>
      <Sidebar mobileOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      <div className="main-content">
        <TopBar
          title={title}
          subtitle={subtitle}
          breadcrumbs={breadcrumbs}
          onOpenNavigation={() => setMobileNavOpen(true)}
        />
        <main className="page-content">{children}</main>
      </div>
      {mobileNavOpen && (
        <button
          type="button"
          className="mobile-nav-scrim"
          aria-label="Close navigation"
          onClick={() => setMobileNavOpen(false)}
        />
      )}
    </div>
  );
}
